export default __webpack_public_path__ + "static/media/mh-1.8273fc7e.png";